import api from "../api";
import { defaultDate, formatDate } from "../utils/formatDate";

export const getStatics = async(startDate, endDate) => {
    return await api.get(`/statistics?startDate=${defaultDate(startDate)}&endDate=${defaultDate(endDate)}`);
  }

export const getStaticsOffer = async(startDate, endDate) => {
    return await api.get(`/statistics/offers?startDate=${defaultDate(startDate)}&endDate=${defaultDate(endDate)}`);
  } 